/* globals Elm, $ */
import { initPorts as initCheckoutPorts } from '../../../../EngageCore.Commerce/Controls/Checkout/main.mjs';
import { initPorts as initPictureUploadPorts } from '../../../../EngageCore.Common/Javascript/pictureUpload.mjs';
import { useUrlParams } from '../../../EngageCore/Views/Common/url.mjs';

const KEY = 'engagecore-Key';

/**
 *
 * @param {object} app The Elm app
 * @param {{node: HTMLElement, flags: object }} options The options
 */
export function initApp(app, { node, flags }) {
	flags.window = { width: window.innerWidth, height: window.innerHeight };

	if (flags.registrationId) {
		flags.headers['Engage-Registration-Context-Registration'] =
			flags.registrationId.toString();
	}

	if (flags.userId) {
		flags.headers.UserId = flags.userId.toString();
	}

	const url = new URL(window.location.href);
	if (url.searchParams.get('listing')?.toLowerCase() === 'true') {
		flags.listing = true;
	}

	const elmApp = app.init({
		node,
		flags,
	});

	initCheckoutPorts(elmApp, flags.paymentProcessor);
	initPictureUploadPorts(elmApp);
	useUrlParams(elmApp);

	elmApp.ports.openModal.subscribe((modalId) => {
		document.getElementById(modalId).showModal();
	});

	elmApp.ports.closeModal.subscribe((modalId) => {
		document.getElementById(modalId).close();
	});

	/**
	 *
	 * @param e
	 * @param link
	 * @param refresh
	 */
	function showDnnModal(e, link, refresh) {
		if (e.button !== 0 || link.prop('disabled')) {
			return;
		}

		let width = 800,
			height = 520,
			str = link.data('width');
		if (str) {
			width = parseInt(str, 10);
		}

		str = link.data('height');
		if (str) {
			height = parseInt(str, 10);
		}

		window.dnnModal.show(
			link.attr('href'),
			false,
			height,
			width,
			refresh,
			'',
		);
		e.preventDefault();
	}

	elmApp.ports.out.subscribe((json) => {
		switch (json[KEY]) {
			case 'InitPopupLinks':
				if (!window.$) {
					break;
				}

				$(document).on(
					'click',
					'.dialog-link',
					function onDialogLinkClick(e) {
						showDnnModal(e, $(this), false);
					},
				);
				break;
			case 'ScrollTo':
				requestAnimationFrame(() => {
					const id = json.value;
					const element = document.getElementById(id);
					if (element) {
						element.scrollIntoView({ behavior: 'smooth' });
					}
				});
				break;
			default:
				break;
		}
	});

	// elmApp.ports.editRegistrationClicked.subscribe((registrationId) => {
	// 	elmApp.ports.onEditRegistrationClicked.send(registrationId);
	// });
}

/**
 * @param {{node: HTMLElement, flags: object }} options The options
 */
export function init(options) {
	initApp(Elm.Views.Registration.Main, options);
}
